export const InvestorRegistrationStep = {
	NotStarted: 0,
	PersonalInformation: 1,
	DocumentVerification: 2,
	Declaration: 3,
};
